import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ImportCompanyDTO, ImportOrderDTO, ImportProjectDTO, ImportUserDTO, LocationItem } from '../../../_models/projects';
import { ImportService } from '../../../_services/import.service';
import { GridComponent, KENDO_GRID } from '@progress/kendo-angular-grid';
import { KENDO_TABSTRIP } from '@progress/kendo-angular-layout';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { KENDO_DROPDOWNLIST } from '@progress/kendo-angular-dropdowns';
import { KENDO_LABEL } from '@progress/kendo-angular-label';
import { CommonModule } from '@angular/common';
import { process } from '@progress/kendo-data-query';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { FormsModule } from '@angular/forms';
import { emptyProjects, Projects } from '../../../_models/admin';
import { NotificationService } from '@progress/kendo-angular-notification';
import { ProjectsService } from '../../../_services/projects.service';
import { DialogModule } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'app-importdata',
  imports: [KENDO_GRID,KENDO_TABSTRIP,KENDO_BUTTON,KENDO_DROPDOWNLIST,KENDO_LABEL,CommonModule,InputsModule,FormsModule,DialogModule],
  templateUrl: './importdata.component.html',
  styleUrl: './importdata.component.css',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImportdataComponent implements OnInit {

  @ViewChild('grid') grid!: GridComponent;
  
 // UI State
  loading = false;
  importLoading = false;
  error: string | null = null;

  // Location dropdown
  locations: LocationItem[] = [];
  selectedLocation: string | null = null;
  selectedProject: Projects = emptyProjects();

  locationWidth = 300;

  // Grid data
  dataProjects: ImportProjectDTO[] = [];
  projects: ImportProjectDTO[] = [];
  dataCompanies: ImportCompanyDTO[] = [];
  companies: ImportCompanyDTO[] = [];
  orders: ImportOrderDTO[] = [];
  dataOrders: ImportOrderDTO[] = [];
  users: ImportUserDTO[] = [];
  dataUsers: ImportUserDTO[] = [];
  filteredUsers: ImportUserDTO[] = [];
  
  portalFilterOptions = [
    { text: 'Show All', value: 'all' },
    { text: 'Yes', value: true },
    { text: 'No', value: false }
  ];

  selectedPortalFilter: any = 'all';

  selectedKeys: Array<ImportProjectDTO['idocs_project_id']> = [];
  selectedCompanyKeys: Array<ImportCompanyDTO['company_id']> = [];
  selectedOrderKeys: Array<ImportOrderDTO['order_no']> = [];
  selectedUserKeys: Array<ImportUserDTO['user_email']> = [];
  searchTerm: string = '';
  searchTermCompany: string = '';
  searchTermOrder: string = '';
  searchTermUser: string = '';
  projectList: Projects[] = [];
  projectname:string ='';
  projectId:number=0;

  showErrorDialog = false;
  errorMessage = '';
  invalidEmails: string[] = [];
  
  constructor(private importSvc: ImportService,private cdr: ChangeDetectorRef,
    private projectsService:ProjectsService,private notificationService:NotificationService) {}

  ngOnInit(): void {
    this.getLocations();
    this.getProjects();
  }

  getLocations(){

      
    const locationLabels: Record<string, string> = {
      'eu-prod': 'EU Production',
      'us-prod': 'US Production',
      'us-test': 'US Test'
    };


    this.importSvc.getLocations()
      .subscribe({
        next: (data) => {
          
          this.locations = data.map(code => ({
            label: locationLabels[code] ?? code,
            value: code
          }));


          this.loading = false;
        },
        error: (err) => {
          this.error = this.readError(err);
          this.loading = false;
        }
      })

  }

  getProjects(){
    this.projectsService.getProjects().subscribe({
      next: (result) => {
        this.projectList = result;
        this.loading = false;
        this.cdr.markForCheck();
      },
      error: (error) => {
        //throw message of some sort
        console.log(error)
        this.showError(JSON.stringify(error.message));
        this.loading = false;
      }
    });
  }

  public showError(value: string): void {
    this.notificationService.show({
      content: value,

      hideAfter: 10000,
      position: { horizontal: "right", vertical: "top" },
      animation: { type: "slide", duration: 400 },
      type: { style: "error", icon: true },
    });
  }

  onLocationChange(value:any) {
    
    this.selectedLocation = value;
    // Clear status and previous data
    this.error = null;
    this.projects = [];
    this.selectedKeys = [];

  }

  onProjectChange(project:Projects){
    // default item ("Select project...") comes back without a projectId
    this.selectedProject = project?.projectId != null ? project : emptyProjects();
    this.error = null;
    this.selectedCompanyKeys = [];
    this.selectedOrderKeys = [];
    this.selectedUserKeys = [];
    this.dataUsers = [];
    this.users = [];
    this.filteredUsers = [];
    this.orders = [];
    this.dataOrders = [];
    this.companies = [];
    this.dataCompanies = [];
  }

  fetchProjects() {
    if (!this.selectedLocation) { return; }

    console.log("this.selectedLocation",this.selectedLocation)
    this.projects = [];
    this.error = null;
    this.selectedKeys = [];
    this.loading = true;
    
    this.importSvc.getProjects(this.selectedLocation)
      .subscribe({
        next: (data) => {
          this.projects = [...data];
          this.dataProjects = this.projects;
          this.loading = false;
          console.log("this.dataProjects",this.dataProjects)
          this.cdr.markForCheck();
          
        },
        error: (err) => {
          this.error = this.readError(err);
          this.loading = false;
          this.cdr.markForCheck();
        }/*,
        complete: () => {
          this.projects = [...this.dataProjects];
          this.loading = false;
        }*/
      });
  }

  fetchCompanies(){
    if (!this.selectedProject) { return; }
    console.log("this.selectedLocation",this.selectedLocation)
    this.companies = [];
    this.error = null;
    this.selectedCompanyKeys = [];
    this.loading = true;

    const locationMap: Record<string, string> = {
      'us production': 'us-prod',
      'eu production': 'eu-prod',
    };

    const rawLocation = this.selectedProject.location?.toLowerCase().trim();

    
    const location = locationMap[rawLocation] ??
      rawLocation?.replace(/\s+/g, '-');


    const projectIdVar = this.selectedProject?.idocs_project_id;
    
    if(projectIdVar!=null){
      this.importSvc.getCompanies(location,projectIdVar)
      .subscribe({
        next: (data) => {
          this.companies = [...data];
          this.dataCompanies = this.companies;
          this.loading = false;
          console.log("this.dataCompanies",this.dataCompanies)
          this.cdr.markForCheck();
          
        },
        error: (err) => {
          this.error = this.readError(err);
          this.loading = false;
          this.cdr.markForCheck();
        }
      });
    }
  }

  fetchOrders(){
    if (!this.selectedProject) { return; }
    console.log("this.selectedLocation",this.selectedLocation)
    this.orders = [];
    this.error = null;
    this.selectedOrderKeys = [];
    this.loading = true;

    const locationMap: Record<string, string> = {
      'us production': 'us-prod',
      'eu production': 'eu-prod',
    };

    const rawLocation = this.selectedProject.location?.toLowerCase().trim();

    
    const location = locationMap[rawLocation] ??
      rawLocation?.replace(/\s+/g, '-');


    const idocsProjectId = this.selectedProject?.idocs_project_id;

    const projectId = this.selectedProject?.projectId;
    
    if(idocsProjectId!=null && projectId!=null){
      this.importSvc.getOrders(location,idocsProjectId,projectId)
      .subscribe({
        next: (data) => {
          this.orders = [...data];
          this.dataOrders = this.orders;
          this.loading = false;
          console.log("this.dataProjects",this.dataOrders)
          this.cdr.markForCheck();
          
        },
        error: (err) => {
          this.error = this.readError(err);
          this.loading = false;
          this.cdr.markForCheck();
        }
      });
    }

  }

  fetchUsers(){
    if (!this.selectedProject) { return; }
    console.log("this.selectedLocation",this.selectedLocation)
    this.users = [];
    this.error = null;
    this.selectedUserKeys = [];
    this.loading = true;

    const locationMap: Record<string, string> = {
      'us production': 'us-prod',
      'eu production': 'eu-prod',
    };

    const rawLocation = this.selectedProject.location?.toLowerCase().trim();

    
    const location = locationMap[rawLocation] ??
      rawLocation?.replace(/\s+/g, '-');


    const idocsProjectId = this.selectedProject?.idocs_project_id;

    
    
    if(idocsProjectId!=null){
      this.importSvc.getUsers(location,idocsProjectId)
      .subscribe({
        next: (data) => {
          this.loading = false;
          
          setTimeout(() => {
            //this.users = [...data];
            this.dataUsers = [...data];
            this.searchTermUser = '';
            //this.filteredUsers = [...data];
            this.selectedPortalFilter = 'all';
            this.applyAllFilters();
            console.log("this.dataUsers",this.dataUsers)
            this.cdr.markForCheck();
          });
          
        },
        error: (err) => {
          this.error = this.readError(err);
          this.loading = false;
          this.cdr.markForCheck();
        },
        complete: () => {
          this.loading = false; // ✅ fallback safety
        }
      });
    }
  }

  applyPortalFilter() {
    if (this.selectedPortalFilter === 'all') {
      this.filteredUsers = [...this.users];
    } else {
      this.filteredUsers = this.users.filter(
        u => u.presentInDb === this.selectedPortalFilter
      );
    }

    console.log('filteredUsers:', this.filteredUsers.length);
  }


  onPortalFilterChange(value: any) {
    this.selectedPortalFilter = value;
    this.applyAllFilters();
  }

  public onSortChange(e: any): void {
    console.log('SORT');
    console.log('dataUsers', this.dataUsers.length);
    console.log('filteredUsers', this.filteredUsers.length);
  }

  private searchDebounce: any;


  public onFilter(inputValue: string): void {
    clearTimeout(this.searchDebounce);
    this.searchDebounce = setTimeout(() => {
      this.searchTerm = inputValue;
      this.projects = process(this.dataProjects, {
        filter: {
          logic: 'or',
          filters: [
            {
              field: 'projectname',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'idocs_project_id',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'idocs_project_number',
              operator: 'contains',
              value: inputValue,
            },

          ],
        },
      }).data;
      
      this.cdr.markForCheck();
    }, 300);

  }

  public onFilterCompany(inputValue: string): void {
    clearTimeout(this.searchDebounce);
    this.searchDebounce = setTimeout(() => {
      this.searchTermCompany = inputValue;

      this.companies = process(this.dataCompanies, {
        filter: {
          logic: 'or',
          filters: [
            {
              field: 'company_name',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'address',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'company_id',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'city',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'state',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'zip',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'phone',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'recipient_code',
              operator: 'contains',
              value: inputValue,
            }
          ],
        },
      }).data; 
      
      this.cdr.markForCheck();
    }, 300);
  
  }

  public onFilterOrder(inputValue: string): void {
    clearTimeout(this.searchDebounce);
    this.searchDebounce = setTimeout(() => {
      this.searchTermOrder = inputValue;

      this.orders = process(this.dataOrders, {
        filter: {
          logic: 'or',
          filters: [
            {
              field: 'order_no',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'order_description',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'company_name',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'recipient_code',
              operator: 'contains',
              value: inputValue,
            }
          ],
        },
      }).data; 
      
      this.cdr.markForCheck();
    }, 300);
  }

  /*public onFilterUser(inputValue: string): void {
    clearTimeout(this.searchDebounce);
    this.searchDebounce = setTimeout(() => {
      this.searchTermUser = inputValue;

      this.users = inputValue ? process(this.dataUsers, {
        filter: {
          logic: 'or',
          filters: [
            {
              field: 'user_email',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'first_name',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'last_name',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'user_type',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'company',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'recipient_code',
              operator: 'contains',
              value: inputValue,
            }
          ],
        },
      }).data : [...this.dataUsers]; 

      this.applyPortalFilter();
      
      this.cdr.markForCheck();
    }, 300);
  }*/

  public onFilterUser(inputValue: string): void {
    clearTimeout(this.searchDebounce);

    this.searchDebounce = setTimeout(() => {
      this.searchTermUser = inputValue;
      this.applyAllFilters();
      this.cdr.markForCheck();
    }, 300);
  }

  private applyAllFilters(): void {
    let data = [...this.dataUsers];

    // Search filter
    if (this.searchTermUser) {
      data = process(data, {
        filter: {
          logic: 'or',
          filters: [
            { field: 'user_email', operator: 'contains', value: this.searchTermUser },
            { field: 'first_name', operator: 'contains', value: this.searchTermUser },
            { field: 'last_name', operator: 'contains', value: this.searchTermUser },
            { field: 'user_type', operator: 'contains', value: this.searchTermUser },
            { field: 'company', operator: 'contains', value: this.searchTermUser },
            { field: 'recipient_code', operator: 'contains', value: this.searchTermUser }
          ]
        }
      }).data;
    }

    // Portal filter
    if (this.selectedPortalFilter !== 'all') {
      data = data.filter(
        u => u.presentInDb === this.selectedPortalFilter
      );
    }

    this.filteredUsers = data;
  }
  
    public rowClass = (context: any) => {
    return context.dataItem?.presentInDb ? 'already-present' : 'has-title';
  };

  public isRowSelectable = (row: any): boolean => {
    return !row.dataItem?.presentInDb;
  };

  public isOrderRowSelectable = (row: any): boolean => {
    
    const dataItem = row?.dataItem ? row.dataItem : row;

    return dataItem.companyPresent && !dataItem.presentInDb;

  };

  public isUserRowSelectable = (row: any): boolean => {
    const dataItem = row?.dataItem ? row.dataItem : row;
     return dataItem.companyPresent && !dataItem.presentInDb;
  };

  
  
  importSelected() {
    if (!this.selectedKeys?.length) { return; }
    this.importLoading = true;

    
    const selectedProjects:ImportProjectDTO[] = this.projects.filter(p =>
      this.selectedKeys.includes(p.idocs_project_id)
    );

    // Option 1: send selected IDs to backend
    const payload = {
      location: this.selectedLocation,
      projects: selectedProjects
    };
    console.log("this.selectedKeys",this.selectedKeys,this.selectedLocation)

    this.importSvc.importProjects(payload)
      .subscribe({
        next: (data) => {
          this.projects = data ?? [];
          this.loading = false;
          this.importLoading = false;
          this.selectedKeys = [];
          this.cdr.markForCheck();
        },
        error: (err) => {
          this.error = this.readError(err);
          this.loading = false;
          this.importLoading = false;
          
          this.cdr.markForCheck();
        },
        complete: () => {
          this.loading = false; // ✅ fallback safety
        }

      });

  }

  importSelectedCompanies(){

    if (!this.selectedCompanyKeys?.length) { return; }
    this.importLoading = true;

    const selectedCompanies:ImportCompanyDTO[] = this.companies.filter(p =>
      this.selectedCompanyKeys.includes(p.company_id)
    );

    const projectId = this.selectedProject?.idocs_project_id;

    this.importSvc.addSelectedCompaniesToDb(selectedCompanies,projectId!)
      .subscribe({
        next: (data) => {
          this.companies = data ?? [];
          this.loading = false;
          this.importLoading = false;
          this.selectedCompanyKeys = [];
          this.cdr.markForCheck();
        },
        error: (err) => {
          this.error = this.readError(err);
          this.loading = false;
          this.importLoading = false;
          
          this.cdr.markForCheck();
        },
        complete: () => {
          this.loading = false; // ✅ fallback safety
        }
      });
  }

  importSelectedOrders() {
    if (!this.selectedOrderKeys?.length) { return; }
    this.importLoading = true;

    const selectedOrders:ImportOrderDTO[] = this.orders.filter(p =>
      this.selectedOrderKeys.includes(p.order_no)
    );

    console.log("selectedOrders",selectedOrders)
    const projectId = this.selectedProject?.projectId;

    this.importSvc.addSelectedOrdersToDb(selectedOrders,projectId!)
      .subscribe({
        next: (data) => {
          this.orders = data ?? [];
          this.loading = false;
          this.importLoading = false;
          this.selectedOrderKeys = [];
          this.cdr.markForCheck();
        },
        error: (err) => {
          this.error = this.readError(err);
          this.loading = false;
          this.importLoading = false;
          
          this.cdr.markForCheck();
        }
      });


  }

  private isValidEmail(email: string): boolean {
    const emailRegex =
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/;

    return emailRegex.test(email);
  }

  importSelectedUsers() {
    if (!this.selectedUserKeys?.length) { return; }

    const selectedUsers:ImportUserDTO[] = this.filteredUsers.filter(p =>
      this.selectedUserKeys.includes(p.user_email)
    );

    console.log("selectedUsers",selectedUsers)
    const projectId = this.selectedProject?.projectId;
    const validUsers: ImportUserDTO[] = [];
    const invalidUsers: ImportUserDTO[] = [];
    selectedUsers.forEach(user => {
     // user.user_email = 'abcd@_gmail.com'
      if (this.isValidEmail(user.user_email)) {
        validUsers.push(user);
      } else {
        invalidUsers.push(user);
      }
    });


    if (invalidUsers.length > 0) {
      this.invalidEmails = invalidUsers.map(u => u.user_email);
      this.showErrorDialog = true;
    }
    // If all selected users are invalid, stop processing
    if (!validUsers.length) {
      this.importLoading = false;
      return;
    }


    this.importLoading = true;

    this.importSvc.addSelectedUsersToDb(validUsers,projectId!)
      .subscribe({
        next: (data) => {
          this.filteredUsers = data ?? [];
          this.loading = false;
          this.importLoading = false;
          this.selectedUserKeys = [];
          this.cdr.markForCheck();
        },
        error: (err) => {
          this.error = this.readError(err);
          this.loading = false;
          this.importLoading = false;
          
          this.cdr.markForCheck();
        }
      });


  }


  onTabSelect(event: any): void {
    const tabIndex = event.index;

    switch (tabIndex) {
      case 0: // Projects tab
        this.resetProjectsTab();
        break;

      case 1: // Companies tab
        this.resetCompaniesTab();
        break;

      case 2: // Order tab
        this.resetOrdersTab();
        break;

      case 3: // User tab
        this.resetUsersTab();
        break;
    }
  }

  resetProjectsTab(): void {
    this.searchTerm = '';
    this.projects = [];
    this.selectedKeys = [];
    this.selectedLocation = null;
    this.error = null;
  }

  resetOrdersTab(): void {
    this.searchTermOrder = '';
    this.orders = [];
    this.dataOrders = [];
    this.selectedOrderKeys = [];
    this.error = null;
  }

  resetCompaniesTab(): void {
    this.searchTermCompany = '';
    this.companies = [];
    this.dataCompanies = [];
    this.selectedCompanyKeys = [];
    this.error = null;
  }
  

  resetUsersTab(): void {
    this.searchTermUser = '';
    this.users = [];
    this.dataUsers = [];
    this.filteredUsers = [];
    this.selectedUserKeys = [];
    this.selectedPortalFilter = 'all';
    this.error = null;
  }


  private readError(err: any): string {
    if (!err) return 'Unknown error';
    if (typeof err === 'string') return err;
    if (err?.error?.message) return err.error.message;
    if (err?.message) return err.message;
    return 'Failed to load projects';
  }


}


export function humanizeLocation(code: string): string {
  if (!code) return '';

  // normalize separators to a single space
  const normalized = code.replace(/[-_]+/g, ' ').trim();

  // tokens split
  const tokens = normalized.split(/\s+/);

  // keep common region acronyms uppercase
  const UPPER_ACRONYMS = new Set([
    'US', 'EU', 'UK', 'UAE', 'APAC', 'EMEA', 'LATAM', 'MEA', 'SEA', 'ANZ'
  ]);

  const words = tokens.map(t => {
    const upper = t.toUpperCase();
    if (UPPER_ACRONYMS.has(upper)) {
      return upper;
    }
    // Capitalize first letter, lower the rest
    return t.charAt(0).toUpperCase() + t.slice(1).toLowerCase();
  });

  return words.join(' ');
}


export function toLocationOptions(codes: string[]): LocationItem[] {
  return (codes ?? []).map(code => ({
    label: humanizeLocation(code),
    value: code
  }));
}